import { apiRequest, apiRequestPaged, buildURL } from './commons/CommonService.Functions';

// models
import { Staff } from '../models/Entities/Staff/Staff';
import {
  CreateStaffCommand,
  StaffFilter,
  UpdateStaffCommand
} from '../models/Entities/Staff/StaffCommands';
import { IPagedResult } from '../models/HttpPagedResult';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'staff';

// Query string builder for the staff search endpoint
const BuildStaffQueryString = (filter: StaffFilter | undefined): string => {
  const parameters = new URLSearchParams();

  parameters.append('PageNumber', String(filter?.PageNumber ?? 1));
  parameters.append('PageSize', String(filter?.PageSize ?? 20));

  if (filter?.SearchText) parameters.append('SearchText', filter.SearchText);

  return parameters.toString();
};

/**
 * Página del listado de staff.
 *
 * Devuelve la envoltura completa y no sólo los registros: la búsqueda y el corte
 * en páginas los resuelve el servidor, así que el total de registros sólo lo sabe
 * él y sin eso el control de paginación no puede dibujarse.
 */
export const GetStaff = async (
  token: string,
  filter?: StaffFilter
): Promise<IPagedResult<Staff[]>> => {
  const requestUrl: string = `${BaseURL}?${BuildStaffQueryString(filter)}`;
  return apiRequestPaged<Staff[]>(requestUrl, token, 'GetStaff');
};

// Get staff member by id
export const GetStaffById = async (token: string, staffId: number): Promise<Staff> => {
  const requestUrl: string = buildURL(BaseURL, staffId);
  return apiRequest<Staff>(requestUrl, token, 'GetStaffById');
};

/** Alta. La API responde con el id del staff creado, no con el registro. */
export const CreateStaff = async (
  token: string,
  payload: CreateStaffCommand
): Promise<number> => {
  return apiRequest<number>(BaseURL, token, 'CreateStaff', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

/**
 * Modificación. El id del staff va en la ruta y otra vez adentro del cuerpo,
 * porque así lo pide el comando de la API.
 */
export const UpdateStaff = async (
  token: string,
  payload: UpdateStaffCommand
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, payload.id);
  return apiRequest<number>(requestUrl, token, 'UpdateStaff', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete staff member
export const DeleteStaff = async (token: string, staffId: number): Promise<void> => {
  const requestUrl: string = buildURL(BaseURL, staffId);
  return apiRequest<void>(requestUrl, token, 'DeleteStaff', {
    method: 'DELETE'
  });
};
